import { MovingWorldsBannerLogoLink } from '../../layout/MovingWorldsLogo';
import { ApplicationSuccessIcon } from './ApplicationSuccessIcon';

type ApplicationResultContentProps = {
  title?: string;
  description: string | React.ReactNode;
  backgroundImage?: string;
};

export const ApplicationResultContent = (props: ApplicationResultContentProps) => {
  const { title, description, backgroundImage } = props;

  const logoutHref = import.meta.env.VITE_API_HOST + '/login/logout';

  return (
    <div className='w-full h-[100vh] flex flex-row'>
      {backgroundImage ?
        <div
          className='hidden h-screen w-1/2 lg:flex justify-start items-start'
          style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundColor: '#F9FAFB',
            backgroundPosition: 'center',
          }}>
          <MovingWorldsBannerLogoLink
            height='20'
            className='flex mt-6 ml-6 text-brand-500'
            customLink={logoutHref}
          />
        </div> :

        <div className='hidden h-screen w-1/2 lg:flex flex-col justify-start items-start bg-secondary-brand-25'
        >
          <MovingWorldsBannerLogoLink
            height='20'
            className='flex mt-6 ml-6 text-brand-500'
            customLink={logoutHref}
          />
          <h2 className='my-auto ml-6 text-[95px] font-bold text-gray-600'>Create
            <span className='text-brand-500'>
              <br />Change.
            </span>
            <br />Be Changed.</h2>
        </div>
      }
      <div className='w-full lg:w-1/2 md:px-8 md:py-4 flex flex-col items-center md:justify-center overflow-y-auto'>
        <div className='flex items-center justify-center md:hidden border-b border-gray-100 w-full px-4 py-3 '>
          <MovingWorldsBannerLogoLink
            height='20'
            className='text-brand-500 p-4'
            customLink={logoutHref}
          />
        </div>
        <div className='flex flex-col gap-8 py-8 w-[320px] md:w-[460px]'>
          <div className='flex flex-col gap-8'>
            {title && <h1 className='text-display-sm font-medium text-gray-700'>{title}</h1>}
            <div className='text-md text-gray-700'>{description}</div>
          </div>
        </div>
      </div>
    </div >
  );
};

type Step = {
  label: string;
  content?: string | React.ReactNode;
  active?: boolean;
};

type ApplicationResultStepperProps = {
  steps: Step[];
};

export const ApplicationResultStepper = (props: ApplicationResultStepperProps) => {
  const { steps } = props;
  const activeStep = steps.findIndex((step) => step.active) || 0;

  return (
    <div className='flex flex-col w-full'>
      {steps.map((step, idx) => (
        <div key={step.label} className='flex gap-4'>
          <div className='flex flex-col items-center'>
            <div className={`rounded-full flex items-center justify-center text-sm font-medium `}>
              {idx < activeStep && (
                <div className='px-1'>
                  <ApplicationSuccessIcon width={32} height={32} />
                </div>
              )}
              {idx === activeStep && (
                <div className='border border-black rounded-full p-0.5'>
                  <ApplicationResultStepperGreenIcon />
                </div>
              )}
              {idx > activeStep && (
                <div className='px-1 -ml-0.5'>
                  <ApplicationResultStepperGreyIcon />
                </div>
              )}
            </div>
            {idx <= activeStep && <div className='w-0.5 flex-1 bg-success-500 mt-1 mb-1' />}
          </div>
          <div className='pb-8'>
            <div className={`mt-1.5 font-semibold text-gray-600 flex`}>{step.label}</div>
            <div className='text-gray-600 text-md mt-2'>{step.content}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

const ApplicationResultStepperGreyIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='white'>
      <rect x='1' y='1' width='30' height='30' rx='15' stroke='#E9EAEB' strokeWidth='2' />
      <circle cx='16' cy='16' r='5' fill='#D5D7DA' />
    </svg>
  );
};

const ApplicationResultStepperGreenIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'>
      <rect width='32' height='32' rx='16' fill='#08875D' />
      <circle cx='16' cy='16' r='5' fill='white' />
    </svg>
  );
};
